import React from 'react';
import { Checkbox } from "@material-tailwind/react";

const CustomCheckBox = ({ name, labelBeforeCliquableLink, labelCliquableLink, routeCliquableLink, labelAfterCliquableLink, setValidity }) => {

    const handleChange = (e) => {
        console.log(e.target.checked);
        setValidity(name, e.target.checked);
    };

    return (
        <div className="flex flex-row items-center">
            <Checkbox
                color='blue'
                name={name}
                label={labelBeforeCliquableLink}
                onChange={handleChange}
                className="dark:text-white"
            />
            <a target="_blank" rel="noreferrer" href={routeCliquableLink} className="font-medium text-blue-700 hover:text-blue-600 dark:text-white">
                    &nbsp;{labelCliquableLink}
            </a>
            &nbsp;{labelAfterCliquableLink}
        </div>
    );
};

export default CustomCheckBox;
